import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/deploy/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/deploy/src/app/homepage/components/ClientTestimonials.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/deploy/src/app/homepage/components/FeaturedProducts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/deploy/src/app/homepage/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/deploy/src/app/homepage/components/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/deploy/src/app/homepage/components/MarketNews.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/deploy/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/deploy/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/deploy/src/components/ui/AppImage.tsx");
